export { default } from './GridCulturalOrganizations.vue'
